import {
  vendorsState
} from "./vendors.state";
import {
  vendorsActions
} from "./vendors.actions";
import {
  vendorsGetters
} from "./vendors.getters";
import {
 vendorsMutations
} from "./vendors.mutations";

export default {
  state: vendorsState,
  actions: vendorsActions,
  getters: vendorsGetters,
  mutations: vendorsMutations
};